<template>
  <div class="qrcode-register">
    <h1>微信扫码注册</h1>

    <p class="p1">扫码关注公众号后可实现快捷登录</p>
    <div class="qrcode-box">
      <t-loading class="qrcode-loading" v-if="!QRcodeImg" indicator />
      <img class="qrcode" v-else :src="QRcodeImg" alt="" />
      <div class="mdsk" v-show="!selectFlag">
        <p>勾选下方协议后<br />可进行扫码注册</p>
      </div>
      <div class="mdsk" v-show="failureFlag">
        <p>
          二维码已过期<br />请点击<span @click="getQRCodeFun">刷新</span
          >重新获取
        </p>
      </div>
    </div>
    <privacyPolicy
      type="qrcode"
      @checkSelect="checkSelect"
      :qrshow="qrshow"
      :selectFlag="selectFlag"
    />
  </div>
</template>

<script>
import { getQRcode, verifyLoginStatus } from "@/../api";
import { zhugeTrack, jumpAfterLogin } from "@/utils/utils";
import privacyPolicy from "../common/privacy-policy.vue";
import { mapState } from "vuex";
export default {
  name: "",
  props: ["referUrl"],
  data() {
    return {
      code: "",
      QRcodeImg: "",
      failureFlag: false, // 二维码失效
      RegisterTime: null,
      qrshow: false,
      selectFlag: false, //是否勾选协议
      qrcodeId: "",
    };
  },
  components: {
    privacyPolicy,
  },

  mounted() {
    // 获取登录二维码
    this.getQRCodeFun();
  },
  methods: {
    //是否勾选协议
    checkSelect() {
      this.selectFlag = !this.selectFlag;
      if (this.selectFlag == true) {
        this.getQRCodeFun();
      } else {
        clearInterval(this.RegisterTime);
      }
    },
    //错误提示组件
    show(message = "默认", duration = 3000) {
      this.toastshow(message);
         const toastTimer= setTimeout(() => {
       this.toastHidden();
        clearTimeout(toastTimer)
      }, duration);
    },
    

    // 获取微信登录二维码
    async getQRCodeFun() {
      let params = {
        rememberme: "1",
      };
      this.QRcodeImg = "";
      this.failureFlag = false;
      const res = await getQRcode(params);
     
      if (res.status == 200) {
        this.QRcodeImg = "data:image/png;base64," + res.data.result.ercodeUrl;
        this.qrcodeId = res.data.result.qrcodeId;
        if (this.selectFlag) {
          this.getQRStatus();
        }
        this.failureFlag = false;
      } else {
        this.failureFlag = true;
        
      }
    },
    // 获取微信二维码状态
    getQRStatus() {
      let params = {
        qrcodeId: this.qrcodeId,
      };
      verifyLoginStatus(params).then((res) => {
        let _this = this;
        let status = res.data.code;
        if (status == 401) {
          // 未登录
          this.RegisterTime = setTimeout(function () {
            _this.getQRStatus();
          }, 2000);
        } else if (status === 410) {
          // 二维码过期
          this.failureFlag = true;
        } else if (status === 200) {
          //判断是否是首次登录，如果是那么就去绑定账号密码
          if (res.data.data.firstFlag == true) {
            let query=res.data.data.wechatLoginVo
            if(this.referUrl){
              query.refer=this.referUrl
            }
            this.$router.push({
              path: "/user/bindAccount",
              query: query,
            });
          } else {
            //登录成功后的跳转
            jumpAfterLogin(this.referUrl);
            zhugeTrack("注册成功",{
              终端:"Web",
              注册方式:"微信"
            });
          }
        } else {
          this.show("注册失败");
        }
      });
    },
  },
  beforeDestroy() {
    // 清除二维码检验登录接口
    clearInterval(this.RegisterTime);
  },
};
</script>

<style lang="scss" scoped>
.qrcode-register {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  height: 100%;
  align-content: flex-start;

  .p1 {
    height: 22px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 22px;
    width: 100%;
    margin: 16px 0 0 0;
  }
  p {
    width: 100%;
  }
  h1 {
    height: 32px;
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1d2129;
    line-height: 32px;
    margin-top: 48px;
    text-align: center;
  }
  .qrcode-box {
    position: relative;
    width: 200px;
    height: 200px;
    margin: 48px auto 24px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    .mdsk {
      position: absolute;
      width: 100%;
      top: 0;
      left: 0px;
      background: rgba(247, 248, 250, 0.96);
      height: 100%;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      text-align: center;
      display: flex;
      align-items: center;
      p {
        height: 44px;
        line-height: 22px;
      }
      span {
        color: #165dff;
        cursor: pointer;
      }
    }
    .qrcode-loading {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 48px;
      height: 48px;
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }
    .qrcode {
      display: block;
      width: 100%;
      height: 100%;
    }
    .tips-mask {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(255, 255, 255, 0.6);
      p {
        position: absolute;
        width: 200px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 8px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: 39px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
      }
    }
  }
  > p {
    margin-top: 10px;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    span {
      cursor: pointer;
    }
  }
}
</style>
